// extracted by mini-css-extract-plugin
export default {"tag":"tag-local__tag___fTsQcI1g","closeBtn":"tag-local__closeBtn___NYIARkmy"};